if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        dsn: 'https://8e571b145e80446fb1ec67e31e5e5200@sentry.io/3716615',
        ignoreErrors: [
            "Non-Error promise rejection captured with value",
        ]
    });
}
